import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { CommonCard } from '../../component/cards/MainCard2';
import { EditButton } from '../../component/buttons';
import { useClinics } from '../../hooks/useClinics';
import ClinicActionsCell from './componets/ClinicActionsCell';

const ClinicsManagement = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const {
        data,
        isLoading,
        paginationModel,
        setPaginationModel,
        rowsPerPageOptions,
        count
    } = useClinics();

    const columns = useMemo(
        () => [
            {
                field: 'name',
                headerName: t('clinics.name'),
                flex: 1,
                renderCell: (params) => params?.value || '-'
            },
            {
                field: 'plan',
                headerName: t('clinics.plan'),
                flex: 1,
                renderCell: (params) => params?.value || '-'
            },
            {
                field: 'email',
                headerName: t('clinics.email'),
                flex: 1,
                renderCell: (params) => params?.value || '-'
            },
            {
                field: 'country',
                headerName: t('clinics.country'),
                flex: 1,
                valueGetter: (params) => params?.row?.address?.country,
                renderCell: (params) => params?.value || '-'
            },
            {
                field: 'actions',
                headerName: t('clinics.actions'),
                headerAlign: 'center',
                align: 'center',
                flex: 1,
                sortable: false,
                filterable: false,
                renderCell: (params) =>
                    params?.row ? <ClinicActionsCell clinic={params.row} /> : null
            }
        ],
        [t]
    );

    return (
        <CommonCard sx={{ m: 2, p: 2 }}>
            {/* Header */}
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography variant="h4" fontWeight={700}>
                    {t('clinics.title')}
                </Typography>

                <EditButton onClick={() => navigate('/mgmt/clinics/create')}>
                    <Typography variant="subtitle2">{t('clinics.create')}</Typography>
                </EditButton>
            </Box>

            {/* Table */}
            <DataGrid
                autoHeight
                rows={data}
                loading={isLoading}
                columns={columns}
                getRowId={(row) => row.uuid}
                rowCount={count}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                pageSizeOptions={rowsPerPageOptions}
            />
        </CommonCard>
    );
};

export default ClinicsManagement;
